import React, { useEffect, useRef } from "react";
import { adsConfig } from "@/lib/ads";

/**
 * <AdSlot slot="1234567890" /> renders a Google AdSense ad unit.
 *
 * Renders nothing if REACT_APP_GOOGLE_ADSENSE_CLIENT isn't configured —
 * so the app stays clean while you set up your AdSense account.
 *
 * Place these in non-critical surfaces (between job cards, sidebar) — never inside
 * the resume/concierge / paid-feature flows.
 */
export default function AdSlot({ slot, format = "auto", responsive = true, className = "", style }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!adsConfig.adsenseClient) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) { console.warn("[AdSlot] adsbygoogle push failed:", err?.message || err); }
  }, []);

  if (!adsConfig.adsenseClient || !slot) return null;

  return (
    <ins
      ref={ref}
      className={`adsbygoogle block ${className}`}
      style={{ display: "block", ...style }}
      data-ad-client={adsConfig.adsenseClient}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? "true" : "false"}
      data-testid={`ad-slot-${slot}`}
    />
  );
}
